<template>
  <div class="visitor-dashboard">
    <!-- Background Image with blur & transparency -->
    <div class="background-image"></div>

    <b-container fluid>
      <!-- <b-row>
        <b-col>
          <div class="page-header">
            <h3 class="page-title">
              <b-icon icon="speedometer2" class="title-icon" />
              Visitor Dashboard
            </h3>
            <p class="page-subtitle">Real-time overview of visitor activity</p>
          </div>
        </b-col>
      </b-row> -->
      
      <!-- Stats Cards -->
      <!-- <b-row>
        <b-col md="3" v-for="stat in statsCards" :key="stat.key">
          <b-card class="glass-card stat-card text-center">
            <h1 class="display-4 stat-value">{{ stat.value }}</h1>
            <p class="stat-label">{{ stat.label }}</p>
            <b-badge :variant="stat.variant || 'primary'" class="stat-badge">{{ stat.subLabel || '' }}</b-badge>
          </b-card>
        </b-col>
      </b-row> -->
      
      <!-- Flags Table -->
      <b-row class="mt-4">
        <b-col>
          <b-card class="glass-card table-card">
            <template #header>
              <div class="table-header">
                <h5 class="mb-0 table-title">
                  <b-icon icon="flag" class="header-icon" />
                  Flags / Issues
                </h5>
                <b-badge variant="danger" class="flags-badge">{{ flagsCount }}</b-badge>
              </div>
            </template>
            
            <b-table 
              :items="flags" 
              :fields="flagFields"
              striped
              hover
              responsive
              class="glass-table"
            >
              <template #cell(status)="data">
                <b-badge :variant="getFlagVariant(data.value)" class="status-badge">
                  {{ formatFlagLabel(data.value) }}
                </b-badge>
              </template>
              
              <template #cell(actions)="data">
                <b-button size="sm" variant="outline-primary" @click="viewCheckin(data.item.id)" class="action-btn">
                  <b-icon icon="eye" />
                </b-button>
              </template>
            </b-table>
            
            <div v-if="flags.length === 0" class="text-center py-5 text-muted empty-state">
              <b-icon icon="check-circle" scale="2" class="empty-icon" />
              <p class="mt-3">No flags today! 🎉</p>
            </div>
          </b-card>
        </b-col>
      </b-row>
      
      <!-- Recent Check-ins -->
      <b-row class="mt-4">
        <b-col>
          <b-card class="glass-card table-card">
            <template #header>
              <div class="table-header">
                <h5 class="mb-0 table-title">
                  <b-icon icon="clock-history" class="header-icon" />
                  Recent Check-ins
                </h5>
                <b-badge variant="info" class="recent-badge">{{ recentCheckins.length }}</b-badge>
              </div>
            </template>
            
            <b-table 
              :items="recentCheckins" 
              :fields="checkinFields"
              striped
              hover
              responsive
              class="glass-table"
            >
              <template #cell(status)="data">
                <b-badge :variant="getStatusVariant(data.value)" class="status-badge">
                  {{ data.value }}
                </b-badge>
              </template>
              
              <template #cell(visitor_type)="data">
                <b-badge :variant="getTypeVariant(data.value)" class="type-badge">
                  {{ data.value || 'EMPLOYEE' }}
                </b-badge>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'OwnerDashboard',
  data() {
    return {
      stats: {
        total: 0,
        new: 0,
        returning: 0,
        employee: 0,
        flags: { NO_CAMERA: 0, FACE_MISMATCH: 0, DUPLICATE: 0 }
      },
      flags: [],
      recentCheckins: [],
      refreshInterval: null
    };
  },
  
  computed: {
    statsCards() {
      const totalFlags = Object.values(this.stats.flags).reduce((a, b) => a + b, 0);
      return [
        { key: 'total', value: this.stats.total, label: 'Total Check-ins', variant: 'primary', subLabel: 'Today' },
        { key: 'new', value: this.stats.new, label: 'New Visitors', variant: 'success', subLabel: 'First time' },
        { key: 'returning', value: this.stats.returning, label: 'Returning', variant: 'info', subLabel: 'Repeat' },
        { key: 'employee', value: this.stats.employee, label: 'Employees', variant: 'warning', subLabel: 'Staff' },
      ];
    },
    flagsCount() {
      return Object.values(this.stats.flags).reduce((a, b) => a + b, 0);
    },
    flagFields() {
      return [
        { key: 'time', label: 'Time' },
        { key: 'visitor_name', label: 'Visitor' },
        { key: 'status', label: 'Status' },
        { key: 'employee_name', label: 'Checked By' },
        { key: 'actions', label: 'Actions' }
      ];
    },
    checkinFields() {
      return [
        { key: 'time', label: 'Time' },
        { key: 'visitor_name', label: 'Visitor' },
        { key: 'visitor_type', label: 'Type' },
        { key: 'status', label: 'Status' },
        { key: 'employee_name', label: 'Checked By' }
      ];
    }
  },
  
  created() {
    this.loadData();
    this.refreshInterval = setInterval(this.loadData, 30000);
  },
  
  beforeDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  
  methods: {
    async loadData() {
      try {
        await Promise.all([
          this.loadStats(),
          this.loadFlags(),
          this.loadRecent()
        ]);
      } catch (error) {
        console.error('Failed to load dashboard data', error);
      }
    },
    
    async loadStats() {
      try {
        const response = await axios.get('/api/visitor/stats/today/', {
          headers: { Authorization: `Bearer ${localStorage.userToken}` }
        });
        this.stats = response.data;
      } catch (error) {
        console.error('Failed to load stats', error);
      }
    },
    
    async loadFlags() {
      try {
        const response = await axios.get('/api/visitor/checkins/', {
          params: { status: 'FLAG_NO_CAMERA,FLAG_FACE_MISMATCH,FLAG_DUPLICATE' },
          headers: { Authorization: `Bearer ${localStorage.userToken}` }
        });
        this.flags = response.data.data.map(item => ({
          ...item,
          time: new Date(item.manual_entry_time).toLocaleTimeString(),
          visitor_name: item.visitor_name || 'Unknown'
        }));
      } catch (error) {
        console.error('Failed to load flags', error);
      }
    },
    
    async loadRecent() {
      try {
        const response = await axios.get('/api/visitor/checkins/', {
          params: { limit: 20 },
          headers: { Authorization: `Bearer ${localStorage.userToken}` }
        });
        this.recentCheckins = response.data.data.map(item => ({
          ...item,
          time: new Date(item.manual_entry_time).toLocaleTimeString(),
          visitor_name: item.visitor_name || 'Unknown'
        }));
      } catch (error) {
        console.error('Failed to load recent checkins', error);
      }
    },
    
    getFlagVariant(status) {
      const variants = {
        'FLAG_NO_CAMERA': 'warning',
        'FLAG_FACE_MISMATCH': 'danger',
        'FLAG_DUPLICATE': 'info'
      };
      return variants[status] || 'secondary';
    },
    
    getStatusVariant(status) {
      return status === 'VERIFIED' ? 'success' : 'warning';
    },
    
    getTypeVariant(type) {
      const variants = {
        'NEW': 'success',
        'RETURNING': 'primary',
        'EMPLOYEE': 'warning'
      };
      return variants[type] || 'secondary';
    },
    
    formatFlagLabel(status) {
      const labels = {
        'FLAG_NO_CAMERA': 'No Camera',
        'FLAG_FACE_MISMATCH': 'Face Mismatch',
        'FLAG_DUPLICATE': 'Duplicate'
      };
      return labels[status] || status;
    },
    
    viewCheckin(id) {
      this.$router.push(`/visitor/checkin/${id}`);
    }
  }
};
</script>

<style scoped>
/* ============================================
   BACKGROUND IMAGE (blurred, transparent)
   ============================================ */
.background-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(8px);
  opacity: 0.7;
  z-index: -1;
  transform: scale(1.1);
  transition: filter 0.3s ease;
}

/* ============================================
   PAGE
   ============================================ */
.visitor-dashboard {
  padding: 24px;
  min-height: 100vh;
  position: relative;
}

/* ============================================
   PAGE HEADER
   ============================================ */
.page-header {
  margin-bottom: 24px;
}

.page-title {
  font-weight: 700;
  color: #0b1a30;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 24px;
  text-shadow: 0 1px 4px rgba(255, 255, 255, 0.4);
}

.title-icon {
  color: #4a6cf7;
}

.page-subtitle {
  color: #1f2a3e;
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  text-shadow: 0 1px 3px rgba(255, 255, 255, 0.5);
}

/* ============================================
   GLASS CARDS
   ============================================ */
.glass-card {
  border: none;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.25);
  overflow: hidden;
}

.glass-card >>> .card-header {
  background: rgba(244, 247, 252, 0.5);
  backdrop-filter: blur(4px);
  border-bottom: 1px solid rgba(220, 226, 236, 0.3);
  padding: 14px 24px;
}

.glass-card >>> .card-body {
  padding: 24px;
  background: transparent !important;
}

/* ============================================
   STAT CARDS
   ============================================ */
.stat-card {
  transition: all 0.3s ease;
  height: 100%;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.stat-value {
  font-size: 2.8rem;
  font-weight: 700;
  color: #0b1a30;
  margin-bottom: 4px;
}

.stat-label {
  color: #3e5670;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 8px;
}

.stat-badge {
  padding: 4px 14px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 20px;
}

/* ============================================
   TABLE CARDS
   ============================================ */
.table-card {
  height: 100%;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: #0b1a30;
  font-size: 17px;
}

.header-icon {
  color: #4a6cf7;
}

.flags-badge,
.recent-badge {
  padding: 4px 14px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 20px;
}

/* ============================================
   GLASS TABLE
   ============================================ */
.glass-table {
  background: transparent !important;
}

.glass-table >>> table {
  background: transparent !important;
}

.glass-table >>> thead th {
  background: rgba(244, 247, 252, 0.4) !important;
  backdrop-filter: blur(4px);
  color: #0b1a30;
  font-weight: 600;
  font-size: 13px;
  border-bottom: 1px solid rgba(220, 226, 236, 0.3);
  padding: 10px 14px;
}

.glass-table >>> tbody tr {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(2px);
  transition: background 0.2s ease;
}

.glass-table >>> tbody tr:hover {
  background: rgba(255, 255, 255, 0.4) !important;
}

.glass-table >>> tbody td {
  padding: 10px 14px;
  border-bottom: 1px solid rgba(220, 226, 236, 0.2);
  color: #1f2a3e;
  font-size: 14px;
  vertical-align: middle;
}

.glass-table >>> tbody tr:nth-child(even) {
  background: rgba(248, 250, 255, 0.15) !important;
}

/* Table Badges */
.status-badge {
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
}

.type-badge {
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
}

/* Action Button */
.action-btn {
  background: rgba(74, 108, 247, 0.1);
  border-color: rgba(74, 108, 247, 0.2);
  color: #4a6cf7;
  transition: all 0.2s ease;
}

.action-btn:hover {
  background: rgba(74, 108, 247, 0.2);
  border-color: #4a6cf7;
  transform: scale(1.05);
}

/* ============================================
   EMPTY STATE
   ============================================ */
.empty-state {
  background: transparent !important;
}

.empty-icon {
  color: rgba(74, 108, 247, 0.3);
}

.empty-state p {
  font-size: 16px;
  color: #3e5670;
  font-weight: 500;
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 992px) {
  .stat-card {
    margin-bottom: 16px;
  }
}

@media (max-width: 768px) {
  .visitor-dashboard {
    padding: 16px;
  }
  
  .stat-value {
    font-size: 2.2rem;
  }
  
  .glass-card >>> .card-body {
    padding: 16px;
  }
  
  .glass-card >>> .card-header {
    padding: 12px 16px;
  }
  
  .table-header {
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .page-title {
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .stat-value {
    font-size: 1.8rem;
  }
  
  .glass-table >>> thead th,
  .glass-table >>> tbody td {
    padding: 6px 10px;
    font-size: 12px;
  }
  
  .glass-table >>> thead th {
    font-size: 11px;
  }
  
  .status-badge,
  .type-badge {
    font-size: 10px;
    padding: 2px 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Visitor/OwnerDashboard.vue